var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 46,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.833 19.304h-3.5v-7.64C31.333 5.175 25.833 0 19 0S6.583 5.175 6.583 11.664v7.64h-3.5C1.333 19.304 0 20.536 0 22.179v20.946C0 44.685 1.333 46 3.083 46h31.834C36.583 46 38 44.686 38 43.125V22.179c-.083-1.643-1.417-2.875-3.167-2.875zM20.667 33.186v4.6c0 .164-.167.41-.417.41h-2.667c-.25 0-.416-.164-.416-.41v-4.6c-1.25-.575-2.084-1.807-2.084-3.204 0-1.971 1.667-3.614 3.834-3.614 2.083 0 3.833 1.643 3.833 3.614 0 1.397-.833 2.629-2.083 3.204zm5.916-13.882h-15.25v-7.475c0-3.943 3.417-7.147 7.667-7.147s7.667 3.204 7.667 7.147l-.084 7.475z",
    fill: "#fff"
  })));
}
export default __webpack_public_path__ + "static/Lock.56f973d7.svg";
export { SvgLock as ReactComponent };